import { render, staticRenderFns } from "./rocketChat.vue?vue&type=template&id=6111bcb8&scoped=true&lang=pug&"
import script from "./rocketChat.vue?vue&type=script&lang=ts&"
export * from "./rocketChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6111bcb8",
  null
  
)

export default component.exports